import script from "./LowcodePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LowcodePage.vue?vue&type=script&setup=true&lang=ts"

import "./LowcodePage.vue?vue&type=style&index=0&id=4d5dc1f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5dc1f5"]])

export default __exports__